export default "__VITE_ASSET__dd9ed628__"